<div class="service-requirement container">
    <div class="d-flex justify-content-between align-items-center">
        <h2 class="improved-page-label d-flex align-items-center">Service Requirement</h2>
        <button type="button" class="btn btn-primary improved-add-btn" (click)="Next()">Next</button>
    </div>
    <div class="top-bar" *ngIf="selectedServiceList.length>0">
        <div class="service-list">
            <button class="service-item" [ngClass]="{'active': service.iMasterServiceId == activeServiceId, 'service-error-box':finalSubmission && service.isSubmitted==false && service.iMasterServiceId != activeServiceId}"
                *ngFor="let service of selectedServiceList" (click)="GetServiceQuestions(service.iMasterServiceId,service.vMasterServiceTitle)">
                <img class="me-1" [src]="imagePath + 'warning-large-icon.svg'" height="16" width="16" alt="" *ngIf="finalSubmission && service.isSubmitted==false && service.iMasterServiceId != activeServiceId">
                {{service.vMasterServiceTitle}}
            </button>
        </div>
        <button type="button" class="service-btn" title="Add/Remove Service"
            (click)="OpenServiceSelectionModal(serviceSelection)">
            <img [src]="imagePath + 'plus-bg.png'" alt="plus" class="me-2">
            <span class="link">Add/Remove Services</span>
        </button>
    </div>
    <div class="question-box" *ngIf="selectedServiceList.length>0">
        <h3 class="q-title d-flex align-items-center">{{activeServiceName}} 
            <span class="error-message d-flex align-items-center" *ngIf="finalSubmission && activeServiceIsSubmitted==false">
                <img [src]="imagePath+'info.svg'" alt="" class="me-2">
                Please answer all of the following questions
            </span>
        </h3>
        <div *ngFor="let question of questionArray;let i=index;trackBy: trackByQuestionId">
            <p class=" quo-title">{{i+1}}. {{question.vMasterQuestion}}<span class="text-danger">*</span></p>
            <div *ngIf="question.iMasterQuestionType == 1" class="answer-container" [ngClass]="{'ai-container': activeServiceName=='AI & Machine Learning'}">
                <!-- for single value -->
                <mat-radio-group>
                    <mat-radio-button class="col-12 col-md-6" [checked]="CheckBindAnswer(question,option)" [ngClass]="{'q-error': finalSubmission && activeServiceIsSubmitted==false && question.answers.length==0}" (change)="optionChange($event,question,option)" *ngFor="let option of question.vMasterQuestionOptions;trackBy: trackById" [value]="option">
                        {{option.opt}}
                    </mat-radio-button>
                </mat-radio-group>
            </div>
            <div *ngIf="question.iMasterQuestionType == 2" class="answer-container" [ngClass]="{'ai-container': activeServiceName=='AI & Machine Learning'}">
                <!-- for multiple values -->
                <mat-checkbox class="" [checked]="CheckBindAnswer(question,option)" [ngClass]="{'q-error': finalSubmission && activeServiceIsSubmitted==false && question.answers.length==0}" (change)="optionChange($event,question,option)" *ngFor="let option of question.vMasterQuestionOptions;trackBy: trackById">{{option.opt}}</mat-checkbox>
            </div>
            <div *ngIf="question.iMasterQuestionType == 3" class="answer-container" [ngClass]="{'ai-container': activeServiceName=='AI & Machine Learning'}">
                <!-- for boolean value -->
               
                    <mat-radio-group>
                        <mat-radio-button class="col-12 col-md-6" [checked]="CheckBindAnswer(question,option)" [ngClass]="{'q-error': finalSubmission && activeServiceIsSubmitted==false && question.answers.length==0}" (change)="optionChange($event,question,option)" *ngFor="let option of question.vMasterQuestionOptions;trackBy: trackById" [value]="option">
                            {{option.opt}}
                        </mat-radio-button>
                    </mat-radio-group>
              
            </div>
            <div *ngIf="question.iMasterQuestionType == 4" class="answer-container input-answer" [ngClass]="{'ai-container': activeServiceName=='AI & Machine Learning'}">
                <!-- for multiple values -->
                <input matInput type="number" class="col-12 col-md-6 input" min="0" [value]="CheckBindAnswer(question)" [ngClass]="{'q-error': finalSubmission && activeServiceIsSubmitted==false && checkInputError(question) }" (input)="optionChange($event,question)" /> <span class="input-unit-text">Units</span>
            </div>
            <div *ngIf="question.iMasterQuestionType == 5" class="answer-container" [ngClass]="{'ai-container': activeServiceName=='AI & Machine Learning'}">
                <!-- for multiple values -->
                <mat-checkbox class="col-12 col-md-6" [checked]="CheckBindAnswer(question,option)" [ngClass]="{'q-error': finalSubmission && activeServiceIsSubmitted==false && question.answers.length==0}" (change)="optionChange($event,question,option)" *ngFor="let option of question.vMasterQuestionOptions;trackBy: trackById">{{option.opt}}</mat-checkbox>
            </div>
        </div>
    </div>
    <div class="no-service my-3" *ngIf="selectedServiceList.length==0">

        <div class="d-flex justify-content-center flex-column">
            <img [src]="imagePath + 'calculator.png'" alt="">
            <p class="e-quote-text text-center"><span class="fw-bold">To create a Quote,</span> Please select the
                services and proceed with the questions and answers.</p>
            <div class="d-flex justify-content-center mt-2"><button type="button"
                    class="btn btn-primary improved-add-btn e-quote-button"
                    (click)="OpenServiceSelectionModal(serviceSelection)">Add Service</button>
            </div>
        </div>
    </div>
</div>

<ng-template #serviceSelection let-c="close" let-d="dismiss">
    <div class="modal-dialog modal-dialog-centered m-0">
        <div class="edit-project-dialog modal-content">
            <div class="d-flex justify-content-between align-items-center">
                <div class="improved-page-label">Select Services 
       
                    <img class="mx-1" matTooltipClass="select-service-tooltip" [matTooltip]="infoText" matTooltipPosition="above" [src]="imagePath + 'info-blue.svg'" alt="info">
           


                <!-- <img class="mx-1" [matTooltip]="infoText" matTooltipPosition="above" [src]="imagePath + 'info-blue.svg'" alt="info"> -->
            </div>
                <button type="button" class="btn" aria-label="Close" (click)="d('Cross click')">
                    <img [src]="imagePath + 'close-icon.svg'" alt="Close" height="15" width="15">
                </button>
            </div>
            <div class="form-container">
              <div class="service-requirement-selection">
                     <mat-checkbox class="service-selection-box"
                            [ngClass]="{'active': CheckSelected(service._id)}" *ngFor="let service of serviceList"
                            [checked]="CheckSelected(service._id)" (change)="ServiceSelection($event,service)">
                            <div [title]="service.vMasterServiceTitle" class="e-quote-modal-card-title">
                                {{service.vMasterServiceTitle}}</div>
                            <div class="e-quote-modal-card-decription">{{service.vMasterServiceDescription}}</div>
                        </mat-checkbox>
                      </div>

                <div class="w-100 d-flex justify-content-end mt-3">
                    <button class="btn btn-primary improved-add-btn" (click)="SaveServiceRequirement()">Save</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>


<ng-template #serviceRequired let-c="close" let-d="dismiss">
    <div class="modal-dialog modal-dialog-centered m-0">
        <div class="warning-service-dialog modal-content">
            <div class="form-container">
                <div class="w-100 d-flex flex-column align-items-center justify-content-center text-center pt-4">
                    <img [src]="imagePath + 'warning-large-icon.svg'" alt="">
                    <p class="warning-title px-3 mt-2 mb-3">All the questions are necessary</p>
                    <!-- <p class="warning-title my-3">{{getNotCompletedServices(notFilled)}} {{notFilled.length>1 ? 'services' : 'service'}} questions are not answered.</p> -->
                    <!-- <p class="warning-subtitle mb-3 mt-3">Please answer all the required questions to proceed further.</p> -->
                    <div class="warning-service-box">
                        <div class="d-flex flex-column justify-content-start p-3">
                            <p class="warning-text mb-3">Kindly address all the questions for all the services you’ve chosen.</p>
                            <div class="d-flex align-items-center my-1" *ngFor="let service of selectedServiceList">
                                <img *ngIf="service.isSubmitted==true" [src]="imagePath + 'warning_checkbox_green.svg'" alt="checked_green" class="me-2">
                                <img *ngIf="service.isSubmitted==false" [src]="imagePath + 'warning_checkbox_red.svg'" alt="checked_green" class="me-2">
                                <span class="warning-subtitle">{{service.vMasterServiceTitle}}</span>
                            </div>
                        </div>
                        <button class="btn btn-primary improved-add-btn mt-1" (click)="Okay()">Okay</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>